import { useEffect, useState } from "react";

import internalServerErrorLottie from "assets/files/internal-server-erorr-lottie.json";
import loadingWholeAppLottie from "assets/files/loading-whole-app-lottie.json";
import { useAuth, useDidMountWithoutLifeCycle } from "hooks";
import Lottie from "lottie-react";
import { getI18n } from "react-i18next";
import { useAppSelector } from "stores";

/**
 * Do things that is required for the app iniatilly.
 * e.g. take token, fetch user info, etc.
 */
export const AppInitializer = () => {
  const [loadedWholeApp, setLoadedWholeApp] = useState(false);
  const { internalServerError, language } = useAppSelector(
    (state) => state.system
  );
  const { isInitializing, initUserSession } = useAuth();

  useDidMountWithoutLifeCycle(() => {
    initUserSession();
  });

  useEffect(
    function handleLanguageChange() {
      const i18n = getI18n();
      if (!i18n) return;
      i18n.changeLanguage(language);
    },
    [language]
  );

  useEffect(() => {
    const onPageLoad = () => setLoadedWholeApp(true);

    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
    }

    return () => {
      window.removeEventListener("load", onPageLoad);
    };
  }, []);

  return (
    <>
      {loadedWholeApp && !isInitializing ? null : (
        <Lottie
          animationData={loadingWholeAppLottie}
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            zIndex: 999999,
            backgroundColor: "#fff",
          }}
        />
      )}
      {internalServerError && (
        <Lottie
          animationData={internalServerErrorLottie}
          style={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            zIndex: 999999,
            backgroundColor: "#fff",
          }}
          onClick={() => window.location.reload()}
        />
      )}
    </>
  );
};
